import React, { createContext, useContext, useState, useEffect } from 'react';

// Import translations from JSON files
import arTranslations from '../locales/ar.json';
import enTranslations from '../locales/en.json';
import kuTranslations from '../locales/ku.json';

const LanguageContext = createContext();

// Combined translations object
const translations = {
  ar: arTranslations,
  en: enTranslations,
  ku: kuTranslations
};

export const LanguageProvider = ({ children }) => {
  const [language, setLanguage] = useState(() => {
    // Get saved language or default to Arabic
    return localStorage.getItem('language') || 'ar';
  });

  useEffect(() => {
    // Save language preference
    localStorage.setItem('language', language);
    
    // Update document direction
    document.documentElement.dir = language === 'en' ? 'ltr' : 'rtl';
    document.documentElement.lang = language;
  }, [language]);

  // Translation function
  const t = (key) => {
    return translations[language]?.[key] || translations['ar']?.[key] || key;
  };

  // Check if RTL
  const isRTL = language !== 'en';

  // Get all available languages
  const languages = [
    { code: 'ar', name: 'العربية', flag: '🇮🇶' },
    { code: 'en', name: 'English', flag: '🇬🇧' },
    { code: 'ku', name: 'کوردی', flag: '🇮🇶' }
  ];

  return (
    <LanguageContext.Provider value={{ 
      language, 
      setLanguage, 
      t, 
      isRTL, 
      languages,
      translations 
    }}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLanguage = () => {
  const context = useContext(LanguageContext);
  if (!context) {
    throw new Error('useLanguage must be used within a LanguageProvider');
  }
  return context;
};

export default LanguageContext;
